import { Reveal } from "@/components/Reveal";
import { ScrambleText } from "@/components/ScrambleText";
import { DeviceImage } from "@/components/DeviceImage";

const FACTS = ["No cloud.", "No unwanted installs.", "No frills."];

export default function DeviceSection() {
  return (
    <section
      id="device"
      data-testid="device-section"
      className="flex min-h-screen items-center px-6 py-28 sm:px-10 lg:px-20"
    >
      <div className="mx-auto grid w-full max-w-7xl items-center gap-16 lg:grid-cols-[55fr_45fr]">
        <Reveal className="flex justify-center lg:justify-start">
          <DeviceImage className="h-80 sm:h-96 lg:h-[32rem]" />
        </Reveal>

        <div>
          <Reveal>
            <p className="text-xs uppercase tracking-[0.35em] text-[#C4A24C]"><ScrambleText text="03 / The Device" /></p>
          </Reveal>
          <ul data-testid="device-facts" className="mt-12 space-y-6">
            {FACTS.map((fact, i) => (
              <Reveal key={fact} delay={0.1 + i * 0.12}>
                <li className="font-serif text-3xl text-[#C4A24C] sm:text-4xl lg:text-5xl">{fact}</li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.6}>
            <p className="mt-14 text-xs uppercase tracking-[0.25em] text-[#6B7280]">
              Patent Pending · Prov. No. 64/025,595
            </p>
          </Reveal>
          <Reveal delay={0.7}>
            <p className="mt-4 italic text-[#E4E5EA]/90">
              Peace of mind today, in a world of tomorrow.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
